import React, { useState, useEffect, createRef } from 'react';
import makeStyles from "@mui/styles/makeStyles";
import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';
import Stack from '@mui/material/Stack';
const useStyles = makeStyles((theme) => ({
  controlLabel: {
    fontFamily: "amatic",
    fontSize: "2rem",
    justifyContent: 'center',
  },
  switch: {
    marginLeft: "0px !important",
    marginRight: "0px !important",
  },
  switchLabel: {
    cursor: "pointer"
  }

}));

const MaterialUISwitch = styled(Switch)(({ theme }) => ({
  width: 62,
  height: 34,
  padding: 7,
  '& .MuiSwitch-switchBase': {
    margin: 1,
    padding: 0,
    transform: 'translateX(6px)',
    '&.Mui-checked': {
      color: '#fff',
      transform: 'translateX(22px)',
      '& .MuiSwitch-thumb:before': {
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      },
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.mode === 'dark' ? '#8796A5' : '#aab4be',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    backgroundColor: '#1976d2',
    width: 32,
    height: 32,
    '&:before': {
      content: "''",
      position: 'absolute',
      width: '100%',
      height: '100%',
      left: 0,
      top: 0,
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: 'cover',
    },
  },
  '& .MuiSwitch-track': {
    opacity: 1,
    backgroundColor: '#aab4be',
    borderRadius: 20 / 2,
  },
}));

interface ModeSwitchProp {
  onModeChange?: (mode: boolean) => void;
  defaultValue: boolean;
  offMenuLabel: string;
  onMenuLabel: string;
  className?: string
}

//const  ModeSwitch: FunctionComponent<ModeSwitchProp> = ({onModeChange, defaultValue, offMenuLabel, onMenuLabel }: ModeSwitchProp) => {
export default function ModeSwitch({onModeChange, defaultValue, offMenuLabel, onMenuLabel, className }: ModeSwitchProp) {
  const styles = useStyles();

  const [defaultChecked ] = useState<boolean>( defaultValue )
  const [currentChecked, setCurrentChecked ] = useState<boolean>( defaultValue )

  let el = createRef<HTMLButtonElement>();

  const toggleSetting = ( on: boolean )=>{
    onSwitchModeChange( null, on );
  }

  const onSwitchModeChange = (e: React.SyntheticEvent<Element, Event > | any, checked: boolean )=> {
    if( onModeChange ) {
      onModeChange( checked )
    }
    setCurrentChecked( checked )
  }
  useEffect(()=> {
    if( currentChecked !== defaultValue ) {
       setCurrentChecked( defaultValue )
    }
  }, [defaultValue, currentChecked] )

  return (
      <Stack direction="row" spacing={1} alignItems="center" justifyItems="center" className={`${styles.controlLabel}`}  >
        <span className={`${styles.switchLabel}`} onClick={()=> toggleSetting( false ) }>{ offMenuLabel }</span>
        <MaterialUISwitch ref={el} sx={{ m: 2}} defaultChecked={defaultChecked} onChange={onSwitchModeChange} 
                          checked={currentChecked} />
        <span className={`${styles.switchLabel}`} onClick={()=> toggleSetting( true ) }>{ onMenuLabel }</span>
      </Stack>
  );
}

//export default ModeSwitch